import React from "react";

export const RightArrowIcon = ({
  width,
  height,
  extraClasses,
  maskId = "path-1-inside-1_584_528",
}) => {
  return (
    <span role="img" className={extraClasses}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width || "100%"}
        height={height || "100%"}
        viewBox="0 0 5 10"
        fill="none"
      >
        <mask id={maskId} fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.384644 0.0999756L5.38464 5.09911L0.384644 10.1"
          />
        </mask>
        <path
          d="M-0.322402 0.807144C-0.71296 0.416653 -0.713015 -0.216512 -0.322525 -0.60707C0.0679659 -0.997628 0.701131 -0.997683 1.09169 -0.607193L-0.322402 0.807144ZM5.38464 5.09911L6.09169 4.39194L6.79886 5.09899L6.09181 5.80615L5.38464 5.09911ZM1.09181 10.807C0.701321 11.1976 0.0681563 11.1976 -0.322402 10.8071C-0.71296 10.4167 -0.713015 9.78349 -0.322525 9.39293L1.09181 10.807ZM1.09169 -0.607193L6.09169 4.39194L4.6776 5.80628L-0.322402 0.807144L1.09169 -0.607193ZM6.09181 5.80615L1.09181 10.807L-0.322525 9.39293L4.67748 4.39206L6.09181 5.80615Z"
          fill="#AAAAAA"
          mask={`url(#${maskId})`}
        />
      </svg>
    </span>
  );
};
